import { map, tileLayer, marker, divIcon, latLngBounds, latLng } from './leaflet-src.esm';

const markerIcon = `<svg width="25" height="41" version="1.1" viewBox="0 0 6.61 10.8" xml:space="preserve" xmlns="http://www.w3.org/2000/svg">
    <defs>
        <filter id="f1" x="-.0714" y="-.0714" width="1.14" height="1.14" color-interpolation-filters="sRGB">
            <feGaussianBlur stdDeviation="0.087758043"/></filter>
        <linearGradient
                id="lg4" x1="1.81" x2="1.81" y1="5.04" y2="7.33" gradientUnits="userSpaceOnUse"><stop stop-color="#4597d0" offset="0"/>
            <stop stop-color="#1975c8" offset="1"/>
</linearGradient>
        <filter id="f4" x="-.0443" y="-.0263" width="1.09" height="1.05" color-interpolation-filters="sRGB">
        <feGaussianBlur stdDeviation="0.055736649"/>
    </filter></defs>
    <path d="m3.32 0.18c-1.77 2e-8 -3.2 1.48-3.2 3.31 0.00269 0.408 0.0782 0.812 0.223 1.19l2.94 6.01 2.69-5.33c0.315-0.571 0.537-1.2 0.539-1.87-1e-7 -1.83-1.43-3.31-3.2-3.31z"
          fill="url(#lg4)" stroke="#2f6f9c" stroke-linecap="round" stroke-linejoin="round" stroke-opacity=".996" stroke-width=".266"/>
    <circle cx="3.3" cy="3.47" r="1.47" fill="#fff" fill-opacity=".996" filter="url(#f1)" opacity=".45"/>
    <circle cx="3.3" cy="3.47" r="1.19" fill="#fff" fill-opacity=".996" stroke="#2f6f9c" stroke-linecap="round"
            stroke-linejoin="round" stroke-opacity=".996" stroke-width=".23"/>
    <path d="m3.32 0.465c-1.59 2e-8 -2.89 1.37-2.89 3.06 0.00243 0.377 0.0706 0.75 0.201 1.1l2.66 5.55 2.43-4.93c0.285-0.528 0.484-1.11 0.486-1.73-1e-7 -1.69-1.29-3.06-2.89-3.06z"
          fill="none" filter="url(#f4)" opacity=".36" stroke="#fff" stroke-linecap="round" stroke-linejoin="round"
          stroke-opacity=".996" stroke-width=".243"/>
</svg>`;

function initGeoMap() {
    const pos = [51.6148345, 15.3223284];

    const contact = map('map-static', {
        // zoomControl: false,
        attributionControl: false,
    }).setView(pos, 17);

    tileLayer('{z}/{x}/{y}.webp', {
        minZoom: 14,
        maxZoom: 17,
        noWrap: true,
        attribution: '',
    }).addTo(contact);

    contact.scrollWheelZoom.disable();
    contact.dragging.disable();
    contact.touchZoom.disable();
    var markerInstance = marker(pos, {
        icon: divIcon({

            html:markerIcon,
            className:'marker-svg',
            iconSize: [25, 41],
            iconAnchor: [12, 41],
            popupAnchor: [0, -41]
        })
    }).addTo(contact);
    markerInstance.bindPopup('<strong>Profesjonalna Szkoła Jazdy Delta</strong></br>Bracka 14/2, 68-100 Żagań<br> <a href="https://g.page/deltazagan" target="_blank"><i>Pokaż na mapie Google </i></a>', {
        closeButton: false
    }).openPopup();
    var bounds = latLngBounds(latLng(51.62045, 15.30971), latLng(51.61141, 15.33794));
    contact.setMaxBounds(bounds);
    contact.on('focus', function () {
        contact.dragging.enable();
    })
    contact.on('blur', function () {
        contact.dragging.disable();
    });
    document.getElementById('map-static').classList.remove('map-static-image');
}


initGeoMap();